import { connect } from 'react-redux'
import SettingsView from 'components/views/settings'

const mapStateToProps = () => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsView)
